// extracted by mini-css-extract-plugin
export default {"container":"InputBx_container__I-M5G","micCircle":"InputBx_micCircle__muSSA","formBx":"InputBx_formBx__Yc6hD","submitText":"InputBx_submitText__QszVS"};